<template>
  <div class="aiPanelDes" style="height: 200px;margin-right: 10px;" @click="Yenile">
    <apexchart v-if="GrafikGoster" type="area" height="200" :options="chartOptions" :series="series"></apexchart>
  </div>
</template>

<script>
export default {

  data() {
    return {
      GrafikGoster: false,
      series: [],
      chartOptions: [],
      Kategori: [],
      Tahsilat: [],
      Tahakkuk: [],
    }
  },
  methods: {
    Yenile() {
      this.$store.dispatch("Get", {path: 'panel/grafik'})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Kategori = response.Kategori
            this.Tahsilat = response.Tahsilat
            this.Tahakkuk = response.Tahakkuk
            this.GrafikCalistir()
            this.GrafikGoster = true
          } else {
            this.$message.error(response.Mesaj);
          }
        });
    },
    GrafikCalistir() {
      this.series = [{
        name: 'Tahakkuk',
        data: this.Tahakkuk
      }, {
        name: 'Tahsilat',
        data: this.Tahsilat
      }]
      this.chartOptions = {

        chart: {
          toolbar: {
            show: false
          },
          id: "Kategori bazlı gelir gider grafiği",
          height: 200,
          type: 'area',
          stacked: true,
          fontFamily: 'Gilroy,Helvetica, Arial, sans-serif',
          animations: {
            enabled: true,
            easing: 'easeinout',
            speed: 1000,
          },
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: [2, 2]
        },
        legend: {
          show: true,
          position: 'top',
        },
        colors: ['#00c292', '#4285f4'],
        xaxis: {
          type: 'category',
          categories: this.Kategori,
          style: {
            fontSize: '10px',
            fontFamily: 'Gilroy, Arial, sans-serif',
            fontWeight: 500,
            cssClass: 'apexcharts-xaxis-label',
          },
        },

      }
    }
  },
  created() {
    this.Yenile();

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Panel/PanelGrafik.vue